import _0047_Mobiles_VSI_UV310 from './icon-images/Mobiles_VSI_UV310.png';
import Mobiles_VSI_UV320_Direct from './icon-images/Mobiles_VSI_UV320_Direct.png';
import Mobiles_VSI_UV320_Flex from './icon-images/Mobiles_VSI_UV320_Flex.png';

export const getImageMobileVSI = (model: string, _configKey: number) => {
  if (model === 'UV320E_DIRECT') {
    return Mobiles_VSI_UV320_Direct;
  } else if (model === 'UV320E_FLEX') {
    return Mobiles_VSI_UV320_Flex;
  } else {
    return _0047_Mobiles_VSI_UV310;
  }
};
